export default {"src":"/_next/static/media/qa.2445fc42.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};